import { Component } from 'react';
import classNames from 'classnames';
import unique from 'unique-selector';
import { documentQuerySelectorSafe, getCssValFloat } from '../../../../modules/dpitUtilsPublic';
import DpitBB from './../../../../modules/core/DpitBB';
import ExclusiveClickListener from '../../../../modules/core/ExclusiveClickListener';


import './dp-target-selector.scss';
import { LAYER_CLASSES_BUILDER } from '../../../../modules/core/DpitBuilderCore';


export const TargetSelectorMode = {
	MOST_PARENT: 'MOST_PARENT',
	ORIGINAL: 'ORIGINAL'
};

export default class TargetSelector extends Component {
	$visualizer = null;

	componentDidMount() {
		if (this.props.dpDebugEn) console.log('[dpit] INIT TargetSelector');
		this.updateBlackLists();

		this.visualizedElementEvents = new ExclusiveClickListener(
			this.selectElement.bind(this),
			this.props.suppressClickEvents,
			true,
			true
		);
	}

	componentDidUpdate(prevProps) {

		this.updateBlackLists();
		if (!prevProps.active && this.props.active) {
			this.enterSelectElementMode();
		}
		else if (prevProps.active && !this.props.active) {
			this.exitSelectElementMode();
		}
		if (this.$visualizer && this.$visualizer.length && this.$visualizer.hasClass(this.props.classBEMRoot + '--confirmed')) {
			if (this.props.hideConfirmed) {
				this.$visualizer.fadeOut(500);
			} else {
				this.$visualizer.fadeIn(500);
			}
		}

	}

	updateBlackLists() {
		this.blackList = this.getClassArray(this.props.selectorBlackList);
		if (this.props.classBEMRoot) this.blackList.push('.' + this.props.classBEMRoot);
		this.blackListExit = this.getClassArray(this.props.selectorBlackListExit);
		this.blacklistTotal = [...this.blackList, ...this.blackListExit];
	}

	getClassArray(classes) {
		let res = [];
		if (Array.isArray(classes)) {
			res = [...classes];
		}
		else if (typeof (classes) === 'string') {
			res = classes.split(' ');
		}
		return res;
	}

	enterSelectElementMode = () => {
		const mainClasses = classNames({
			[this.props.classBEMRoot]: true,
			[this.props.className]: this.props.className,
			[this.props.classBEMRoot + '--active']: this.props.active
		});
		document.documentElement.classList.add(LAYER_CLASSES_BUILDER.targetSelectingMode);
		this.visualizedElementEvents.clear();

		this.$visualizer = ($('.' + this.props.classBEMRoot));
		if (!this.$visualizer.length) {
			this.$visualizer = $(`<div class="${mainClasses}"></div>`).prependTo(this.props.container);
		}
		else {
			this.$visualizer.attr('class', '');
			this.$visualizer.addClass(mainClasses);
		}
		this.$visualizer.fadeIn(700, () => {
			$(document).on('mousemove', '*', this.visualizeHoveredElement);
		});

		// Initial position
		this.visualizeInitialTarget();
	};

	exitSelectElementMode = (hideVisualizer = true) => {
		document.documentElement.classList.remove(LAYER_CLASSES_BUILDER.targetSelectingMode);
		this.clearVisualizedTarget(this.visualizedTargetEl);
		$(document).off('mousemove', '*', this.visualizeHoveredElement);
		if (hideVisualizer && this.$visualizer && this.$visualizer.length && !this.props.leaveConfirmedVisible) {
			this.$visualizer.fadeOut(300);
		}
	};

	clearVisualizedTarget(targetEl) {

		if (targetEl) {
			targetEl.classList.remove(this.props.visualizedTargetClass);
		}
		this.visualizedTargetEl = null;
		this.visualizedElementEvents.clear();
	}

	activateVisualizedTarget(targetEl) {
		if (targetEl && !this.isTargetOnBlackList(targetEl, this.blacklistTotal)) {
			this.visualizedTargetEl = targetEl;
			targetEl.classList.add(this.props.visualizedTargetClass);
			this.adjustVisualizer(targetEl);
			this.visualizedElementEvents.addElement(targetEl);
		}
	}

	visualizeHoveredElement = (event) => {
		if (event.target && this.visualizedTargetEl !== event.target) {
			this.adjustVisualizer(event.target);
			this.clearVisualizedTarget(this.visualizedTargetEl);
			this.activateVisualizedTarget(event.target);
		}
	};

	isTargetOnBlackList(targetEl, blackList) {
		for (const val of blackList) {
			if ($(targetEl).closest(val).length) return true;
		}
		return false;
	}

	adjustVisualizer = (targetEl) => {
		if (targetEl) {
			if (!this.isTargetOnBlackList(targetEl, this.blacklistTotal)) {
				this.$visualizer.show();
				const $target = $(targetEl);
				this.$visualizer.offset($target.offset());
				this.$visualizer.outerWidth($target.outerWidth());
				this.$visualizer.outerHeight($target.outerHeight());
			}
			else {
				this.$visualizer.hide();
			}
		}
		else {
			this.$visualizer.hide();
		}
	};

	createBoundingBoxFromElementWithMargin(element) {
		return DpitBB.extendByMarginBB(DpitBB.fromElement(element, false), {
			top: getCssValFloat(element, 'margin-top', 0),
			left: getCssValFloat(element, 'margin-left', 0),
			bottom: getCssValFloat(element, 'margin-bottom', 0),
			right: getCssValFloat(element, 'margin-right', 0),
		});
	}

	isElementSamePosAndSize = (el1, el2, tolerancePx) => {
		if (el1 && el2) {
			if (document.documentElement === el1) return false;
			const bb1 = this.createBoundingBoxFromElementWithMargin(el1);
			const bb2 = this.createBoundingBoxFromElementWithMargin(el2);
			if (bb1 && bb2) {
				const keys = Object.keys(bb1);
				for (const key of keys) {
					if (key != 'width' && key != 'height') {
						if (Math.abs(bb1[key] - bb2[key]) > tolerancePx) return false;
					}
				}
				return true;
			}
		}
		return false;
	};


	trySelectParent = (element) => {
		let resParentEl = element;
		while (this.isElementSamePosAndSize(element, resParentEl.parentNode, 3)) {
			resParentEl = resParentEl.parentNode;
		}
		return resParentEl;
	};

	visualizeInitialTarget() {
		this.adjustVisualizer(documentQuerySelectorSafe(this.props.initialTargetSelector));
	}

	selectElement = (event) => {
		const isOnExitBL = this.isTargetOnBlackList(event.target, this.blackListExit);
		const isOnBL = this.isTargetOnBlackList(event.target, this.blackList);

		if ((isOnExitBL && !isOnBL) || (!isOnExitBL && !isOnBL)) {
			this.exitSelectElementMode(false);
		}

		if (isOnExitBL && !isOnBL /* sub button to switch exit btn position */) {
			this.visualizeInitialTarget();
		}

		if ((!isOnExitBL && !isOnBL)) {
			let selector = '';
			let isError = false;
			let selectedEl = null;
			switch (this.props.mode) {
				case TargetSelectorMode.MOST_PARENT: selectedEl = this.trySelectParent(event.target); break;
				default: selectedEl = event.target;
			}


			try {
				selector = unique(selectedEl, {
					selectorTypes: this.props.selectorTypes
				});
				this.$visualizer.addClass(this.props.classBEMRoot + '--confirmed');

			}
			catch (exc) {
				if (selectedEl?.id) {
					selector = `#${selectedEl.id}`;
				}
				else {
					isError = true;
				}
			}
			this.$visualizer.fadeOut(300, () => {
				this.clearVisualizedTarget(event.target);
				this.props.onTargetSelected(selector, selectedEl, isError);
			});
			/*setTimeout(() => {


				this.$visualizer.fadeOut(300, () => {
					this.clearVisualizedTarget(event.target);
					this.props.onTargetSelected(selector, selectedEl, isError);
				});
			}, 300);*/ //wait for final animation

			return false;
		}
		else if (isOnExitBL) {
			if (this.props.initialTargetElement) {
				this.visualizeInitialTarget();
				//this.adjustVisualizer($S(this.props.initialTargetElement));
				this.$visualizer.addClass(this.props.classBEMRoot + '--confirmed');
			}
			return true;

		}

	};

	render = () => null;
}